module.exports = __webpack_public_path__ + "img/arrow-left-large.e023fdba.svg";